export default __webpack_public_path__ + "static/media/step-four.62e80709.png";